export const ACTION_SET_EXPLORE_OPEN = 'ACTION_SET_EXPLORE_OPEN';
export const ACTION_SET_SEARCH_OPEN = 'ACTION_SET_SEARCH_OPEN';
export const ACTION_SET_MOBILE_SEARCH_OPEN = 'ACTION_SET_MOBILE_SEARCH_OPEN';
export const ACTION_SET_MOBILE_EXPLORE_OPEN = 'ACTION_SET_MOBILE_EXPLORE_OPEN';
export const ACTION_SET_EXPLORE_CLOSE_CLICKED = 'ACTION_SET_EXPLORE_CLOSE_CLICKED';

interface Displays {
    exploreOpen: boolean;
    searchOpen: boolean;
    mobileExploreOpen: boolean;
    mobileSearchOpen: boolean;
    exploreCloseClicked: boolean;
}

interface SetExploreCloseClicked {
    type: typeof ACTION_SET_EXPLORE_CLOSE_CLICKED;
    exploreCloseClicked: boolean;
}
interface SetExploreOpen {
    type: typeof ACTION_SET_EXPLORE_OPEN;
    exploreOpen: boolean;
}
interface SetSearchOpen {
    type: typeof ACTION_SET_SEARCH_OPEN;
    searchOpen: boolean;
}

interface SetMobileExploreOpen {
    type: typeof ACTION_SET_MOBILE_EXPLORE_OPEN;
    mobileExploreOpen: boolean;
}
interface SetMobileSearchOpen {
    type: typeof ACTION_SET_MOBILE_SEARCH_OPEN;
    mobileSearchOpen: boolean;
}

export type DisplayState = Displays;
export type DisplayActionTypes =
    | SetExploreOpen
    | SetMobileSearchOpen
    | SetMobileExploreOpen
    | SetSearchOpen
    | SetExploreCloseClicked;
